/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `initialize` - initialize
 * * `start` - start
 * * `pause` - pause
 * * `shutdown` - shutdown
 * * `queue` - queue
 * * `dequeue` - dequeue
 * @export
 */
export const ActionNameEnum = {
  INITIALIZE: "initialize",
  START: "start",
  PAUSE: "pause",
  SHUTDOWN: "shutdown",
  QUEUE: "queue",
  DEQUEUE: "dequeue",
} as const;
export type ActionNameEnum = (typeof ActionNameEnum)[keyof typeof ActionNameEnum];

export function instanceOfActionNameEnum(value: any): boolean {
  for (const key in ActionNameEnum) {
    if (Object.prototype.hasOwnProperty.call(ActionNameEnum, key)) {
      if (ActionNameEnum[key as keyof typeof ActionNameEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ActionNameEnumFromJSON(json: any): ActionNameEnum {
  return ActionNameEnumFromJSONTyped(json, false);
}

export function ActionNameEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ActionNameEnum {
  return json as ActionNameEnum;
}

export function ActionNameEnumToJSON(value?: ActionNameEnum | null): any {
  return value as any;
}

export function ActionNameEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): ActionNameEnum {
  return value as ActionNameEnum;
}
